"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonWithSpinner = exports.BannerWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const button_1 = require("@kyruus/button");
const ui_theme_1 = require("@kyruus/ui-theme");
exports.BannerWrapper = styled_1.default.div `
  > div {
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }
`;
exports.StyledButtonWithSpinner = (0, styled_1.default)(button_1.ButtonWithSpinner) `
  width: ${({ aboveMd }) => (aboveMd ? 'auto' : '100%')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
`;
//# sourceMappingURL=styles.js.map